import React from "react";
import { Table } from "antd";
import type { TableProps } from "antd";

const ScrollableTable: React.FC<TableProps<any>> = (props) => {
  return (
    <div style={{ overflowX: "auto" }}>
      <Table {...props} />
    </div>
  );
};

export default ScrollableTable;
